import config from '@/config';

const AppRedirect = () => (window.location.href = config.appUrl);

export default AppRedirect;
